export class FetchError extends Error {
    readonly parent?: Error;
    constructor(parent?: unknown) {
        super('Ha ocurrido un error');
        if (parent instanceof Error) this.parent = parent;
    }
}
